import React, { useState } from 'react';
import Login from './Login';
import Register from './Register';
import AzureLogin from './AzureLogin';
import ForgotPassword from './ForgotPassword';

interface AuthFlowProps {
  userType: 'externo' | 'interno';
  onBack: () => void;
}

type AuthView = 'login' | 'register' | 'forgot-password';

const AuthFlow: React.FC<AuthFlowProps> = ({ userType, onBack }) => {
  const [currentView, setCurrentView] = useState<AuthView>('login');

  // Si es usuario interno, mostrar login de Azure
  if (userType === 'interno') {
    return <AzureLogin onBack={onBack} />;
  }

  // Si es usuario externo, mostrar login/registro/recuperar contraseña
  if (currentView === 'register') {
    return (
      <Register 
        onSwitchToLogin={() => setCurrentView('login')}
        onBack={onBack}
      />
    );
  }

  if (currentView === 'forgot-password') {
    return (
      <ForgotPassword 
        onBack={() => setCurrentView('login')}
      />
    );
  }

  return (
    <Login 
      onSwitchToRegister={() => setCurrentView('register')} 
      onForgotPassword={() => setCurrentView('forgot-password')}
    />
  );
};

export default AuthFlow;

